module.exports = __webpack_public_path__ + "img/icon337.e5b13771.png";